import * as React from "react";
const SvgTriangleDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 9 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Polygon 2", d: "M4.75 5L0.852886 0.5L8.64711 0.499999L4.75 5Z", fill: "#2C684E" }));
export default SvgTriangleDown;
